import type { RawLocation } from 'vue-router';

import { useContext, useRouter } from '@nuxtjs/composition-api';
import { useCart } from '~/modules/checkout/composables/useCart';
import { useUser } from '~/modules/customer/composables/useUser';

type LinkGroup = { title: string; items: LinkGroupItem[] };
type LinkGroupItem = { id: string; label: string; link?: RawLocation };

export const useSidebarLinkGroups = () => {
  const { localeRoute } = useContext();
  const { logout } = useUser();
  const { clear } = useCart();
  const router = useRouter();

  const sidebarLinkGroups: LinkGroup[] = [
    {
      title: 'Personal details',
      items: [
        {
          id: 'my-profile',
          label: 'My profile',
          link: { name: 'customer-my-profile' },
        },
        {
          id: 'address-details',
          label: 'Addresses details',
          link: { name: 'customer-addresses-details' },
        },
        {
          id: 'my-wishlist',
          label: 'My wishlist',
          link: { name: 'customer-my-wishlist' },
        },
      ],
    },
    {
      title: 'Order details',
      items: [
        {
          id: 'order-history',
          label: 'Order history',
          link: { name: 'customer-order-history' },
        },
      ],
    },
    {
      title: 'Blood Tests',
      items: [
        {
          id: 'blood-tests',
          label: 'My reports',
          link: { name: 'reports' },
        },
        {
          id: 'log-out',
          label: 'Log out',
        },
      ],
    },
  ];

  const logoutUser = async () => {
    await logout({});
    await clear({});
    await router.push(localeRoute({ name: 'home' }));
  };

  return { sidebarLinkGroups, logoutUser };
};
